
import { IFetchManyLeadsProtocol } from '@/domain/application/protocols/leads/IFetchManyLeadsProtocol'
import { ILeadsRepository } from '@/domain/application/repositories/ILeadsRepository'
import { FetchManyLeadsUseCase } from '@/domain/application/useCases/leads/fetchManyLeads'
import { prismaService } from '@/infra/database/prisma'
import { PrismaLeadsRepository } from '@/infra/database/prisma/repositories/prismaLeadsRepository'
import { Request, Response } from 'express'
import { LeadDetailsPresenter } from '../../presenters/LeadDetailsPresenter'
import { OrderBy, OrderType } from '@/domain/application/protocols/leads/enums/Order'
import { z, ZodError } from 'zod'

const fetchLeadsByParametersQuerySchema = z.object({
  orderType: z.enum(['ASC', 'DESC']).optional().default('ASC'),
  orderBy: z.enum(['NAME', 'EMAIL', 'PHONE', 'CREATEDAT']).optional().default('CREATEDAT'),
  page: z.coerce.number().min(1).optional().default(1),
  limit: z.coerce.number().min(1).max(100).default(20)
})

export class FetchManyLeadsController {
  private repository: ILeadsRepository = new PrismaLeadsRepository(prismaService)
  private useCase: IFetchManyLeadsProtocol = new FetchManyLeadsUseCase(
    this.repository,
  )
  
  async handle(request: Request, response: Response) {
    try {
      const { limit, orderBy, orderType, page } = fetchLeadsByParametersQuerySchema.parse(request.query)
      const {leads, currentPage, nextPage, previousPage, totalData, totalPages, perPage} = await this.useCase.execute({limit, orderBy: OrderBy[orderBy], orderType: OrderType[orderType], page})
      return response.status(200).send({
        leads: leads.map(LeadDetailsPresenter.toHttp),
        previous_page: previousPage,
        current_page: currentPage,
        next_page: nextPage,
        last_page: totalPages,
        total: totalData,
        per_page: perPage,
        from: (currentPage - 1) * perPage + 1,
        to: currentPage * perPage
      })
    } catch (error) {
      if (error instanceof ZodError) {           
        return response.status(400).json({
          message: 
          error.issues[0].path.toString() === 'originName' ? 'Nome da praça no formato inválido' 
          : error.issues[0].path.toString() === 'orderType' ? 'Tipo da ordenação no formato inválido' 
          : error.issues[0].path.toString() === 'orderBy' ? 'Campo de ordenação no formato inválido' 
          : error.issues[0].path.toString() === 'page' ? 'Página no formato inválido'
          : error.issues[0].path.toString() === 'limit' ? 'Items por página no formato inválido'
          : 'Erro na validação dos dados',
          error: error.flatten().fieldErrors
        }).send()
      }
      if(error instanceof Error) {
        return response.status(400).send({
          message: error.message,
        })
      }
      return response.status(500).json({
        message: 'Internal server error.'
      }).send()
    }
  }
}